import { useEffect } from 'react';
import { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function InvestWithUs() {
  //   const [step, setStep] = useState('initial');
  // const [selectedOption, setSelectedOption] = useState('');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


 
  return (
    <div className="bg-slate-900">
  {/* Hero Section */}
  <div className="relative md:h-[70vh] h-[40vh] overflow-hidden">
    {/* Background Image with Zoom Out */}
    <motion.div
      initial={{ scale: 1.2 }}
      animate={{ scale: 1 }}
      transition={{ duration: 3, ease: "easeOut" }}
      className="absolute inset-0 bg-cover bg-center"
      style={{ backgroundImage: "url('/assets/images/invest-section-img1.png')" }}
    />

    {/* Overlay */}
    <div className="absolute inset-0 bg-black bg-opacity-30" />

    {/* Heading on the Left */}
    <div className="relative z-10 h-full flex items-end sm:items-center justify-start px-5 sm:px-10 pb-10 sm:pb-0">
      <motion.h1
        initial={{ opacity: 0, y: 80 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 2, ease: "easeOut" }}
        className="text-white text-5xl sm:text-4xl md:text-7xl font-semibold bg-black bg-opacity-40 px-4 py-3 sm:px-6 sm:py-6 rounded-xl shadow-xl max-w-[90%] sm:max-w-[70%]"
      >
        Our Services
      </motion.h1>
    </div>
  </div>








<div className="bg-white">


{/* Info Section */}
<div className="flex flex-col md:flex-row items-center justify-between px-5 sm:px-10 py-16 max-w-7xl mx-auto gap-10">
  {/* Text Content */}
  <motion.div
    initial={{ opacity: 0, x: -50 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 2.2, delay: 0.7 }}
    className="w-full md:w-1/2"
  >
    <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-slate-900">Kitchen Renovations</h2>
    <p className="text-black text-base sm:text-lg leading-relaxed">
    Upgrade your kitchen into a modern, functional, and stylish space designed around your lifestyle. We handle complete kitchen renovations including layout redesigns, cabinet installation, countertops, lighting, flooring, plumbing, tiling, and finishing touches.
    </p>
    <Link to="/about" >
    <button className="relative overflow-hidden py-3 px-8 mt-4 text-white font-semibold bg-teal-500 shadow-xl text-lg group">
      <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 group-hover:from-slate-900 group-hover:to-slate-900 animate-slide-bg transition-all duration-500 ease-in-out"></span>
      <span className="relative z-10">Learn More</span>
    </button>
    </Link>
  </motion.div>

 <motion.div
    initial={{ opacity: 0, scale: 1.1 }}
    whileInView={{ opacity: 1, scale: 1 }}
    transition={{ duration: 2.4, delay: 0.6, ease: "easeOut", repeat: false }}
    className="md:w-1/2 relative group"
  >
    {/* Container with padding for visual frame space */}
    <div className="relative p-[22px] overflow-visible">
      {/* Image box */}
      <div className="overflow-hidden shadow-2xl relative z-10">
        <img
          src="/assets/images/kitchenrenovation.jpg"
      alt="Kitchen Renovation"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>

      {/* Animated Decorative Frames */}
      <motion.div
        animate={{ y: [0, -18, 5, 0] }}
        transition={{ repeat: Infinity, duration: 3 }}
        className="absolute top-0 left-0 w-[60px] h-[160px] border-t-[22px] border-l-[22px] border-slate-900 z-20"
      ></motion.div>

      <motion.div
        animate={{ y: [0, 18, -5, 0] }}
        transition={{ repeat: Infinity, duration: 3 }}
        className="absolute bottom-0 right-0 w-[60px] h-[160px] border-b-[22px] border-r-[22px] border-slate-900 z-20"
      ></motion.div>
    </div>
  </motion.div>

</div>



    {/* Reversed Section With Image On Left */}
    <div className="flex flex-col md:flex-row-reverse items-center justify-between px-5 sm:px-10 py-16 max-w-7xl mx-auto gap-10 overflow-x-hidden">
  {/* Text Content */}
  <motion.div
    initial={{ opacity: 0, x: 50 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 2.2, delay: 0.5 , repeat: false}}
    className="md:w-1/2 pl-5"
  >
    <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-slate-900">House Extensions</h2>
    <p className="text-black text-base sm:text-lg leading-relaxed">
      Need more space for your growing family or lifestyle? Our house extension services help you expand your property while increasing its functionality and value. We manage every stage of the project from planning to completion.
    </p>
    <Link to="/contact">
    <button className="relative overflow-hidden py-3 px-8 mt-4 text-white font-semibold  bg-teal-500 shadow-xl text-lg group">
      <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 group-hover:from-tslate-900 group-hover:to-slate-900 animate-slide-bg transition-all duration-500 ease-in-out"></span>
      <span className="relative z-10">Discover More</span>
    </button></Link>
  </motion.div>

  {/* Image Content */}
  <motion.div
    initial={{ opacity: 0, scale: 1.1 }}
    whileInView={{ opacity: 1, scale: 1 }}
    transition={{ duration: 2.4, delay: 0.6, ease: "easeOut", repeat: false }}
    className="md:w-1/2 relative group"
  >
    {/* Container with padding for visual frame space */}
    <div className="relative p-[22px] overflow-visible">
      {/* Image box */}
      <div className="overflow-hidden shadow-2xl relative z-10">
        <img
          src="/assets/images/houseextension.jpg"
          alt="House Extension"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>

      {/* Animated Decorative Frames */}
      <motion.div
        animate={{ y: [0, -18, 5, 0] }}
        transition={{ repeat: Infinity, duration: 3 }}
        className="absolute top-0 left-0 w-[60px] h-[160px] border-t-[22px] border-l-[22px] border-slate-900 z-20"
      ></motion.div>

      <motion.div
        animate={{ y: [0, 18, -5, 0] }}
        transition={{ repeat: Infinity, duration: 3 }}
        className="absolute bottom-0 right-0 w-[60px] h-[160px] border-b-[22px] border-r-[22px] border-slate-900 z-20"
      ></motion.div>
    </div>
  </motion.div>
</div>

<div className="flex flex-col md:flex-row items-center justify-between px-5 sm:px-10 py-16 max-w-7xl mx-auto gap-10">
  {/* Text Content */}
  <motion.div
    initial={{ opacity: 0, x: -50 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 2.2, delay: 0.7 }}
    className="w-full md:w-1/2"
  >
    <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-slate-900">Attic Conversions</h2>
    <p className="text-black text-base sm:text-lg leading-relaxed">
    Transform unused attic space into a practical and beautiful room. Whether you want an additional bedroom, office, playroom, or storage area, we create attic conversions that maximize your home's potential.
    </p>
    <Link to="/about" >
    <button className="relative overflow-hidden py-3 px-8 mt-4 text-white font-semibold bg-teal-500 shadow-xl text-lg group">
      <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 group-hover:from-slate-900 group-hover:to-slate-900 animate-slide-bg transition-all duration-500 ease-in-out"></span>
      <span className="relative z-10">Learn More</span>
    </button>
    </Link>
  </motion.div>

  {/* Image Content */}
 
 <motion.div
    initial={{ opacity: 0, scale: 1.1 }}
    whileInView={{ opacity: 1, scale: 1 }}
    transition={{ duration: 2.4, delay: 0.6, ease: "easeOut", repeat: false }}
    className="md:w-1/2 relative group"
  >
    {/* Container with padding for visual frame space */}
    <div className="relative p-[22px] overflow-visible">
      {/* Image box */}
      <div className="overflow-hidden shadow-2xl relative z-10">
        <img
          src="/assets/images/atticconversion.jpg"
      alt="Attic Conversion"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>

      {/* Animated Decorative Frames */}
      <motion.div
        animate={{ y: [0, -18, 5, 0] }}
        transition={{ repeat: Infinity, duration: 3 }}
        className="absolute top-0 left-0 w-[60px] h-[160px] border-t-[22px] border-l-[22px] border-slate-900 z-20"
      ></motion.div>

      <motion.div
        animate={{ y: [0, 18, -5, 0] }}
        transition={{ repeat: Infinity, duration: 3 }}
        className="absolute bottom-0 right-0 w-[60px] h-[160px] border-b-[22px] border-r-[22px] border-slate-900 z-20"
      ></motion.div>
    </div>
  </motion.div>


</div>



    {/* Reversed Section With Image On Left */}
    <div className="flex flex-col md:flex-row-reverse items-center justify-between px-5 sm:px-10 py-16 max-w-7xl mx-auto gap-10 overflow-x-hidden">
  {/* Text Content */}
  <motion.div
    initial={{ opacity: 0, x: 50 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 2.2, delay: 0.5 , repeat: false}}
    className="md:w-1/2 pl-5"
  >
    <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-slate-900">Skimming</h2>
    <p className="text-black text-base sm:text-lg leading-relaxed">
      Achieve smooth and flawless walls and ceilings with our professional skimming services. We prepare surfaces carefully to ensure a perfect finish ready for painting or decorating.
    </p>
    <Link to="/contact">
    <button className="relative overflow-hidden py-3 px-8 mt-4 text-white font-semibold  bg-teal-500 shadow-xl text-lg group">
      <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 group-hover:from-tslate-900 group-hover:to-slate-900 animate-slide-bg transition-all duration-500 ease-in-out"></span>
      <span className="relative z-10">Discover More</span>
    </button></Link>
  </motion.div>

  {/* Image Content */}
  <motion.div
    initial={{ opacity: 0, scale: 1.1 }}
    whileInView={{ opacity: 1, scale: 1 }}
    transition={{ duration: 2.4, delay: 0.6, ease: "easeOut", repeat: false }}
    className="md:w-1/2 relative group"
  >
    {/* Container with padding for visual frame space */}
    <div className="relative p-[22px] overflow-visible">
      {/* Image box */}
      <div className="overflow-hidden shadow-2xl relative z-10">
        <img
          src="/assets/images/skimming.jpg"
          alt="Skimming"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>

      {/* Animated Decorative Frames */}
      <motion.div
        animate={{ y: [0, -18, 5, 0] }}
        transition={{ repeat: Infinity, duration: 3 }}
        className="absolute top-0 left-0 w-[60px] h-[160px] border-t-[22px] border-l-[22px] border-slate-900 z-20"
      ></motion.div>

      <motion.div
        animate={{ y: [0, 18, -5, 0] }}
        transition={{ repeat: Infinity, duration: 3 }}
        className="absolute bottom-0 right-0 w-[60px] h-[160px] border-b-[22px] border-r-[22px] border-slate-900 z-20"
      ></motion.div>
    </div>
  </motion.div>
</div>

<div className="flex flex-col md:flex-row items-center justify-between px-5 sm:px-10 py-16 max-w-7xl mx-auto gap-10">
  {/* Text Content */}
  <motion.div
    initial={{ opacity: 0, x: -50 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 2.2, delay: 0.7 }}
    className="w-full md:w-1/2"
  >
    <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-slate-900">Flooring</h2>
    <p className="text-black text-base sm:text-lg leading-relaxed">
    We provide high-quality flooring installation services to enhance the beauty and durability of your property. From modern flooring designs to classic finishes, we help you choose the perfect option for your space.
    </p>
    <Link to="/about" >
    <button className="relative overflow-hidden py-3 px-8 mt-4 text-white font-semibold bg-teal-500 shadow-xl text-lg group">
      <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 group-hover:from-slate-900 group-hover:to-slate-900 animate-slide-bg transition-all duration-500 ease-in-out"></span>
      <span className="relative z-10">Learn More</span>
    </button>
    </Link>
  </motion.div>

  {/* Image Content */}
  
 <motion.div
    initial={{ opacity: 0, scale: 1.1 }}
    whileInView={{ opacity: 1, scale: 1 }}
    transition={{ duration: 2.4, delay: 0.6, ease: "easeOut", repeat: false }}
    className="md:w-1/2 relative group"
  >
    {/* Container with padding for visual frame space */}
    <div className="relative p-[22px] overflow-visible">
      {/* Image box */}
      <div className="overflow-hidden shadow-2xl relative z-10">
        <img
          src="/assets/images/flooring.jpg"
      alt="Flooring"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>

      {/* Animated Decorative Frames */}
      <motion.div
        animate={{ y: [0, -18, 5, 0] }}
        transition={{ repeat: Infinity, duration: 3 }}
        className="absolute top-0 left-0 w-[60px] h-[160px] border-t-[22px] border-l-[22px] border-slate-900 z-20"
      ></motion.div>

      <motion.div
        animate={{ y: [0, 18, -5, 0] }}
        transition={{ repeat: Infinity, duration: 3 }}
        className="absolute bottom-0 right-0 w-[60px] h-[160px] border-b-[22px] border-r-[22px] border-slate-900 z-20"
      ></motion.div>
    </div>
  </motion.div>


</div>



    {/* Reversed Section With Image On Left */}
    <div className="flex flex-col md:flex-row-reverse items-center justify-between px-5 sm:px-10 py-16 max-w-7xl mx-auto gap-10 overflow-x-hidden">
  {/* Text Content */}
  <motion.div
    initial={{ opacity: 0, x: 50 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 2.2, delay: 0.5 , repeat: false}}
    className="md:w-1/2 pl-5"
  >
    <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-slate-900">Bathroom Renovations</h2>
    <p className="text-black text-base sm:text-lg leading-relaxed">
      Transform your bathroom into a modern and relaxing space with our expert renovation services. We handle everything from layout planning and plumbing to tiling and final finishing.
    </p>
    <Link to="/contact">
    <button className="relative overflow-hidden py-3 px-8 mt-4 text-white font-semibold  bg-teal-500 shadow-xl text-lg group">
      <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 group-hover:from-tslate-900 group-hover:to-slate-900 animate-slide-bg transition-all duration-500 ease-in-out"></span>
      <span className="relative z-10">Discover More</span>
    </button></Link>
  </motion.div>

  {/* Image Content */}
  <motion.div
    initial={{ opacity: 0, scale: 1.1 }}
    whileInView={{ opacity: 1, scale: 1 }}
    transition={{ duration: 2.4, delay: 0.6, ease: "easeOut", repeat: false }}
    className="md:w-1/2 relative group"
  >
    {/* Container with padding for visual frame space */}
    <div className="relative p-[22px] overflow-visible">
      {/* Image box */}
      <div className="overflow-hidden shadow-2xl relative z-10">
        <img
          src="/assets/images/bathroomrenovation.jpg"
          alt="Bathroom Renovation"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>

      {/* Animated Decorative Frames */}
      <motion.div
        animate={{ y: [0, -18, 5, 0] }}
        transition={{ repeat: Infinity, duration: 3 }}
        className="absolute top-0 left-0 w-[60px] h-[160px] border-t-[22px] border-l-[22px] border-slate-900 z-20"
      ></motion.div>

      <motion.div
        animate={{ y: [0, 18, -5, 0] }}
        transition={{ repeat: Infinity, duration: 3 }}
        className="absolute bottom-0 right-0 w-[60px] h-[160px] border-b-[22px] border-r-[22px] border-slate-900 z-20"
      ></motion.div>
    </div>
  </motion.div>
</div>


<div className="flex flex-col md:flex-row items-center justify-between px-5 sm:px-10 py-16 max-w-7xl mx-auto gap-10">
  {/* Text Content */}
  <motion.div
    initial={{ opacity: 0, x: -50 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 2.2, delay: 0.7 }}
    className="w-full md:w-1/2"
  >
    <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-slate-900">Tiling</h2>
    <p className="text-black text-base sm:text-lg leading-relaxed">
      We offer professional wall and floor tiling services for kitchens, bathrooms, hallways, and more. Our team delivers precise tile installation with attention to detail and high-quality finishes.
    </p>
    <Link to="/about" >
    <button className="relative overflow-hidden py-3 px-8 mt-4 text-white font-semibold bg-teal-500 shadow-xl text-lg group">
      <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 group-hover:from-slate-900 group-hover:to-slate-900 animate-slide-bg transition-all duration-500 ease-in-out"></span>
      <span className="relative z-10">Learn More</span>
    </button>
    </Link>
  </motion.div>

  {/* Image Content */}
  <motion.div
    initial={{ opacity: 0, scale: 1.1 }}
    whileInView={{ opacity: 1, scale: 1 }}
    transition={{ duration: 2.4, delay: 0.6, ease: "easeOut", repeat: false }}
    className="md:w-1/2 relative group"
  >
    {/* Container with padding for visual frame space */}
    <div className="relative p-[22px] overflow-visible">
      {/* Image box */}
      <div className="overflow-hidden shadow-2xl relative z-10">
        <img
          src="/assets/images/tiling.jpg"
      alt="Tiling"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>

      {/* Animated Decorative Frames */}
      <motion.div
        animate={{ y: [0, -18, 5, 0] }}
        transition={{ repeat: Infinity, duration: 3 }}
        className="absolute top-0 left-0 w-[60px] h-[160px] border-t-[22px] border-l-[22px] border-slate-900 z-20"
      ></motion.div>

      <motion.div
        animate={{ y: [0, 18, -5, 0] }}
        transition={{ repeat: Infinity, duration: 3 }}
        className="absolute bottom-0 right-0 w-[60px] h-[160px] border-b-[22px] border-r-[22px] border-slate-900 z-20"
      ></motion.div>
    </div>
  </motion.div>


</div>



    {/* Reversed Section With Image On Left */}
    <div className="flex flex-col md:flex-row-reverse items-center justify-between px-5 sm:px-10 py-16 max-w-7xl mx-auto gap-10 overflow-x-hidden">
  {/* Text Content */}
  <motion.div
    initial={{ opacity: 0, x: 50 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 2.2, delay: 0.5 , repeat: false}}
    className="md:w-1/2 pl-5"
  >
    <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-slate-900">Offices</h2>
    <p className="text-black text-base sm:text-lg leading-relaxed">
     We provide professional office renovation and fit-out services designed to create modern, functional, and productive workspaces tailored to your business needs.
    </p>
    <Link to="/contact">
    <button className="relative overflow-hidden py-3 px-8 mt-4 text-white font-semibold  bg-teal-500 shadow-xl text-lg group">
      <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 group-hover:from-tslate-900 group-hover:to-slate-900 animate-slide-bg transition-all duration-500 ease-in-out"></span>
      <span className="relative z-10">Discover More</span>
    </button></Link>
  </motion.div>

  {/* Image Content */}
  <motion.div
    initial={{ opacity: 0, scale: 1.1 }}
    whileInView={{ opacity: 1, scale: 1 }}
    transition={{ duration: 2.4, delay: 0.6, ease: "easeOut", repeat: false }}
    className="md:w-1/2 relative group"
  >
    {/* Container with padding for visual frame space */}
    <div className="relative p-[22px] overflow-visible">
      {/* Image box */}
      <div className="overflow-hidden shadow-2xl relative z-10">
        <img
          src="/assets/images/officerenovation.jpg"
          alt="office"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>

      {/* Animated Decorative Frames */}
      <motion.div
        animate={{ y: [0, -18, 5, 0] }}
        transition={{ repeat: Infinity, duration: 3 }}
        className="absolute top-0 left-0 w-[60px] h-[160px] border-t-[22px] border-l-[22px] border-slate-900 z-20"
      ></motion.div>

      <motion.div
        animate={{ y: [0, 18, -5, 0] }}
        transition={{ repeat: Infinity, duration: 3 }}
        className="absolute bottom-0 right-0 w-[60px] h-[160px] border-b-[22px] border-r-[22px] border-slate-900 z-20"
      ></motion.div>
    </div>
  </motion.div>
</div>










{/* Info Section */}
<div className="flex justify-center items-center px-4 sm:px-8 py-14 sm:py-20 max-w-7xl mx-auto relative">

  {/* Image Content */}
  <motion.div
    initial={{ opacity: 0, scale: 1.1 }}
    whileInView={{ opacity: 1, scale: 1 }}
    transition={{ duration: 2.2, delay: 0.7, ease: "easeOut" }}
    className="relative w-full max-w-5xl"
  >
    <div className="relative mx-auto h-[300px] sm:h-[500px] overflow-hidden rounded-xl shadow-2xl">
      <motion.img
        src="/assets/images/invest-section-img-2.png"
        alt="About Us"
        initial={{ scale: 1.2 }}
        whileInView={{ scale: 1 }}
        transition={{ duration: 3, ease: "easeOut" }}
        className="w-full h-full object-cover"
      />
    </div>

    {/* Responsive Card with Curtain Animation */}
    <motion.div
  initial={{ x: -100, y: 100, opacity: 0 }}
  whileInView={{ x: 0, y: 0, opacity: 1 }}
  transition={{ duration: 0.6, ease: "easeOut", delay: 0.6 }}
  className="absolute bottom-[-90px] sm:bottom-[-100px] left-4 sm:left-[-100px] bg-teal-500 text-white shadow-2xl p-8 sm:p-10 w-[95%] sm:w-[420px] z-20 mb-6 sm:mb-0"
>

      <h3 className="text-xl sm:text-3xl font-bold mb-3">Ready to Start Your Project?</h3>
      <p className="text-sm sm:text-base leading-relaxed mb-4">
        Contact us today to discuss your renovation needs and get a free consultation. Our team is here to help you bring your vision to life with expert craftsmanship and personalized service.
      </p>
      <Link to="/contact">
      <button

className="relative overflow-hidden py-3 px-8 mt-4 text-teal-500 hover:text-white font-semibold bg-white shadow-xl text-lg group"
>
<span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 group-hover:from-tslate-900 group-hover:to-slate-900 animate-slide-bg transition-all duration-500 ease-in-out"></span>
<span className="relative z-10">Contact Now!</span>
  </button></Link>
    </motion.div>
  </motion.div>
</div>
</div>



<div className="relative h-screen flex items-center justify-center overflow-hidden">
  {/* Background Video */}
  <video
    className="absolute inset-0 w-full h-full object-cover"
    autoPlay
    loop
    muted
    playsInline
  >
    <source src="/assets/videos/investor-rise-bg-map.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>

  {/* Overlay */}
  <div className="absolute inset-0 bg-black bg-opacity-30" />

  <div className="relative z-10 text-center text-white max-w-xl px-6 py-12 border-t-4 border-l-4 border-b-4 border-r-4 border-transparent rounded-xl shadow-2xl">
    {/* Animated Half Frame Corners */}
    <motion.div
      initial={{ width: 0, height: 0 }}
      whileInView={{ width: "4rem", height: "4rem" }}
      viewport={{ once: false }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="absolute top-0 left-0 border-t-8 border-l-8 border-teal-500"
    />
    <motion.div
      initial={{ width: 0, height: 0 }}
      whileInView={{ width: "4rem", height: "4rem" }}
      viewport={{ once: false }}
      transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
      className="absolute bottom-0 right-0 border-b-8 border-r-8 border-teal-500"
    />

    <motion.h2
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: false }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="text-4xl md:text-5xl font-bold mb-4"
    >
      Frequently Asked Questions
    </motion.h2>

    <motion.p
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: false }}
      transition={{ delay: 0.2, duration: 0.6, ease: "easeOut" }}
      className="text-lg mb-6"
    >
      Find answers to some of the most commonly asked questions.
    </motion.p>

    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: 0.4, duration: 0.5 }}
    >
      <Link to="/faqs">
        <button className="relative overflow-hidden py-3 px-8 mt-4 text-white font-semibold bg-teal-500 shadow-xl text-lg group">
          <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 group-hover:from-tslate-900 group-hover:to-slate-900 animate-slide-bg transition-all duration-500 ease-in-out"></span>
          <span className="relative z-10">Get Started</span>
        </button>
      </Link>
    </motion.div>
  </div>
</div>




</div>

  
  );
}
